import type { ReactNode } from "react";
import { BP } from "./theme.ts";

type CityGroundProps = {
	minX: number;
	maxX: number;
	minY: number;
	maxY: number;
};

/** Subtle drafting grid in screen space over the city bounds. */
export function CityGround({ minX, maxX, minY, maxY }: CityGroundProps) {
	const step = 48;
	const lines: ReactNode[] = [];
	let k = 0;
	for (let x = Math.floor(minX / step) * step; x <= maxX + step; x += step) {
		const major = k++ % 4 === 0 ? BP.gridMajor : BP.gridMinor;
		lines.push(<line key={`v-${x}`} x1={x} y1={minY - 80} x2={x} y2={maxY + 80} stroke={major} strokeWidth={major === BP.gridMajor ? 0.6 : 0.35} />);
	}

	k = 0;
	for (let y = Math.floor(minY / step) * step; y <= maxY + step; y += step) {
		const major = k++ % 4 === 0 ? BP.gridMajor : BP.gridMinor;
		lines.push(<line key={`h-${y}`} x1={minX - 120} y1={y} x2={maxX + 120} y2={y} stroke={major} strokeWidth={major === BP.gridMajor ? 0.6 : 0.35} />);
	}

	return <g className="bp-ground bp-ground-breathe">{lines}</g>;
}
